import Image from "next/image";

import { ModelNoImage } from "@/components/ModelNoImage";
import { MixedModelConstructedNoDates } from "@/types/types";
import { getSizesString } from "@/utils/getSizesString";

const getModelCount = (mixedModel: MixedModelConstructedNoDates): number => {
  if (mixedModel.model4Id !== null && mixedModel.model4Id !== "") {
    return 4;
  }
  if (mixedModel.model3Id !== null && mixedModel.model3Id !== "") {
    return 3;
  }
  return 2;
};

export function ShowImageMixedModel({
  mixedModel,
}: {
  mixedModel: MixedModelConstructedNoDates;
}) {
  const modelCount = getModelCount(mixedModel);

  if (modelCount === 4) {
    return (
      <div className="aspect-h-7 aspect-w-10 relative w-full">
        <div className="absolute inset-0 grid h-full w-full grid-cols-2 grid-rows-2">
          <div className="relative h-full w-full overflow-hidden rounded-tl-3xl">
            {mixedModel.model1PresignedUrlImage !== null ?
              <Image
                src={mixedModel.model1PresignedUrlImage}
                alt={"Image of one of the models used"}
                className="h-full w-full object-cover"
                fill={true}
                sizes={getSizesString({
                  sm: 50,
                  md: 50,
                  lg: 25,
                  rest: 25,
                })}
              />
            : <ModelNoImage className="text-4xl" />}
          </div>
          <div className="relative h-full w-full overflow-hidden rounded-tr-3xl">
            {mixedModel.model2PresignedUrlImage !== null ?
              <Image
                src={mixedModel.model2PresignedUrlImage}
                alt={"Image of one of the models used"}
                className="h-full w-full object-cover"
                fill={true}
                sizes={getSizesString({
                  sm: 50,
                  md: 50,
                  lg: 25,
                  rest: 25,
                })}
              />
            : <ModelNoImage className="text-4xl" />}
          </div>
          <div className="relative h-full w-full overflow-hidden rounded-bl-3xl">
            {mixedModel.model3PresignedUrlImage !== null ?
              <Image
                src={mixedModel.model3PresignedUrlImage}
                alt={"Image of one of the models used"}
                className="h-full w-full object-cover"
                fill={true}
                sizes={getSizesString({
                  sm: 50,
                  md: 50,
                  lg: 25,
                  rest: 25,
                })}
              />
            : <ModelNoImage className="text-4xl" />}
          </div>
          <div className="relative h-full w-full overflow-hidden rounded-br-3xl">
            {mixedModel.model4PresignedUrlImage !== null ?
              <Image
                src={mixedModel.model4PresignedUrlImage}
                alt={"Image of one of the models used"}
                className="h-full w-full object-cover"
                fill={true}
                sizes={getSizesString({
                  sm: 50,
                  md: 50,
                  lg: 25,
                  rest: 25,
                })}
              />
            : <ModelNoImage className="text-4xl" />}
          </div>
        </div>
      </div>
    );
  }

  if (modelCount === 3) {
    return (
      <div className="aspect-h-7 aspect-w-10 relative w-full">
        <div className="absolute inset-0 grid h-full w-full grid-cols-3">
          <div className="relative h-full w-full overflow-hidden rounded-l-3xl">
            {mixedModel.model1PresignedUrlImage !== null ?
              <Image
                src={mixedModel.model1PresignedUrlImage}
                alt={"Image of one of the models used"}
                className="h-full w-full object-cover"
                fill={true}
                sizes={getSizesString({
                  sm: 33,
                  md: 33,
                  lg: 33,
                  rest: 33,
                })}
              />
            : <ModelNoImage className="text-4xl" />}
          </div>
          <div className="relative h-full w-full overflow-hidden">
            {mixedModel.model2PresignedUrlImage !== null ?
              <Image
                src={mixedModel.model2PresignedUrlImage}
                alt={"Image of one of the models used"}
                className="h-full w-full object-cover"
                fill={true}
                sizes={getSizesString({
                  sm: 33,
                  md: 33,
                  lg: 33,
                  rest: 33,
                })}
              />
            : <ModelNoImage className="text-4xl" />}
          </div>
          <div className="relative h-full w-full overflow-hidden rounded-r-3xl">
            {mixedModel.model3PresignedUrlImage !== null ?
              <Image
                src={mixedModel.model3PresignedUrlImage}
                alt={"Image of one of the models used"}
                className="h-full w-full object-cover"
                fill={true}
                sizes={getSizesString({
                  sm: 33,
                  md: 33,
                  lg: 33,
                  rest: 33,
                })}
              />
            : <ModelNoImage className="text-4xl" />}
          </div>
        </div>
      </div>
    );
  }

  // Default 2-model split view
  return (
    <div className="aspect-h-7 aspect-w-10 relative w-full">
      <div className="absolute inset-0 grid h-full w-full grid-cols-2">
        <div className="relative h-full w-full overflow-hidden rounded-l-3xl">
          {mixedModel.model1PresignedUrlImage !== null ?
            <Image
              src={mixedModel.model1PresignedUrlImage}
              alt={"Image of one of the models used"}
              className="object-cover"
              fill={true}
              sizes={getSizesString({
                sm: 100,
                md: 100,
                lg: 50,
                rest: 33,
              })}
            />
          : <ModelNoImage />}
        </div>

        <div className="relative h-full w-full overflow-hidden rounded-r-3xl">
          {mixedModel.model2PresignedUrlImage !== null ?
            <Image
              src={mixedModel.model2PresignedUrlImage}
              alt={"Image of one of the models used"}
              className="object-cover"
              fill={true}
              sizes={getSizesString({
                sm: 100,
                md: 100,
                lg: 50,
                rest: 33,
              })}
            />
          : <ModelNoImage />}
        </div>
      </div>
    </div>
  );
}
